import { useOutletContext } from "react-router-dom";

import OrganizationSettingsFinanceView from "../../views/OrganizationSettingsView/OrganizationSettingsFinanceView";

export default function OrganizationSettingsFinance() {
	const { organization } = useOutletContext();

	return <OrganizationSettingsFinanceView organization={organization} />;
}
